import * as types from '../ActionTypes/ExercisesActionTypes';
import { convertTimeToFormat } from '../../Utils';

const initialState = {
    statuses: {
        allExercisesLoading: false,
        moreAllExercisesLoading: false,
        recentExercisesLoading: false,
        byTypeExercisesLoading: false,
        moreByTypeExercisesLoading: false,
    },
    allExercises: {
        allExercisesList: [],
        allExercisesOffsetId: 0,
        moreAllExercisesToLoad: true,
    },
    recentExercises: {
        recentExercisesList: [],
    },
    byTypeExercises: {
        byTypeExercisesList: [],
        byTypeExercisesOffsetId: 0,
        moreByTypeExercisesToLoad: true,
    },
};

export function ExercisesReducer(state = initialState, { type, payload, meta, ...action }) {
    switch (type) {
        case types.GET_ALL_EXERCISES_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    allExercisesLoading: true,
                },
            };
        }

        case types.GET_ALL_EXERCISES_SUCCESS: {
            let formattedExercises = [];
            const { response, offsetId } = payload;

            if (response.length > 0) formattedExercises = formatExercisesData(response);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    allExercisesLoading: false,
                },
                allExercises: {
                    ...state.allExercises,
                    allExercisesList: [...formattedExercises],
                    allExercisesOffsetId: offsetId,
                },
            };
        }

        case types.GET_MORE_EXERCISES_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    moreAllExercisesLoading: true,
                },
            };
        }

        case types.GET_MORE_EXERCISES_SUCCESS: {
            let formattedExercises = [];
            const { response, offsetId } = payload;

            if (response.length > 0) formattedExercises = formatExercisesData(response);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    moreAllExercisesLoading: false,
                },
                allExercises: {
                    ...state.allExercises,
                    allExercisesList: [...state.allExercises.allExercisesList, ...formattedExercises],
                    allExercisesOffsetId: offsetId,
                },
            };
        }

        case types.GET_RECENT_EXERCISES_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    recentExercisesLoading: true,
                },
            };
        }

        case types.GET_RECENT_EXERCISES_SUCCESS: {
            let formattedExercises = [];
            if (payload.length > 0) formattedExercises = formatExercisesData(payload);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    recentExercisesLoading: false,
                },
                recentExercises: {
                    ...state.recentExercises,
                    recentExercisesList: [...formattedExercises],
                },
            };
        }

        case types.GET_EXERCISES_BY_TYPE_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    byTypeExercisesLoading: true,
                },
            };
        }

        case types.GET_EXERCISES_BY_TYPE_SUCCESS: {
            let formattedExercises = [];
            const { response, offsetId } = payload;

            if (response.length > 0) formattedExercises = formatExercisesData(response);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    byTypeExercisesLoading: false,
                },
                byTypeExercises: {
                    ...state.byTypeExercises,
                    byTypeExercisesList: [...formattedExercises],
                    byTypeExercisesOffsetId: offsetId,
                },
            };
        }

        case types.GET_MORE_EXERCISES_BY_TYPE_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    moreByTypeExercisesLoading: true,
                },
            };
        }

        case types.GET_MORE_EXERCISES_BY_TYPE_SUCCESS: {
            let formattedExercises = [];
            const { response, offsetId } = payload;

            if (response.length > 0) formattedExercises = formatExercisesData(response);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    moreByTypeExercisesLoading: false,
                },
                byTypeExercises: {
                    ...state.byTypeExercises,
                    byTypeExercisesList: [...state.byTypeExercises.byTypeExercisesList, ...formattedExercises],
                    byTypeExercisesOffsetId: offsetId,
                },
            };
        }

        case types.NO_MORE_EXERCISES: {
            return {
                ...state,
                allExercises: {
                    ...state.allExercises,
                    moreAllExercisesToLoad: false,
                },
            };
        }

        case types.NO_MORE_EXERCISES_BY_TYPE: {
            return {
                ...state,
                byTypeExercises: {
                    ...state.byTypeExercises,
                    moreByTypeExercisesToLoad: false,
                },
            };
        }

        default: {
            return state;
        }
    }
}

const formatExercisesData = exercises => {
    return exercises.map(exercise => {
        let res = {
            id: exercise.exercise_id,
            MET_value: exercise.MET_value,
            isDistanceRequired: exercise.is_distance_required,
            distance: exercise.is_distance_required ? exercise.distance : 'N/A',
            kgs:
                exercise.as_KG_lifted &&
                (exercise.as_KG_lifted !== '' &&
                    exercise.as_KG_lifted !== 'N/A' &&
                    exercise.as_KG_lifted !== 'N/A Cardio ' &&
                    exercise.as_KG_lifted !== 'Cardio')
                    ? exercise.as_KG_lifted
                    : 0,
            time:
                exercise.default_set_length_s && exercise.default_set_length_s !== ''
                    ? convertTimeToFormat(exercise.default_set_length_s)
                    : '00:00:00',
            bodyweightPercentage: exercise.as_p_of_bodyweight,
            whiteImage: exercise.white_image_url,
            orangeImage: exercise.orange_image_url,
            name: exercise.name,
        };

        if (exercise.is_distance_required) {
            res.reps = 'N/A';
            res.distance = exercise.distance;
        } else {
            res.reps =
                exercise.default_reps_per_set && exercise.default_reps_per_set !== ''
                    ? exercise.default_reps_per_set
                    : 0;
            res.distance = 'N/A';
        }

        return res;
    });
};



// WEBPACK FOOTER //
// ./src/Store/Reducers/ExercisesReducer.js